<template>
  <AppButtonIcon
    effect="rotate"
    icon="far fa-times"
    class="modal-close-button"
    @click="closeModal"
  />
</template>

<script>
// Utilities
import RouterModalControl from 'Mixins/RouterModalControl'
// Components
import AppButtonIcon from 'Ui/AppButtonIcon'

export default {
  name: 'ModalCloseButton',

  components: {
    AppButtonIcon,
  },

  mixins: [RouterModalControl],
}
</script>

<style scoped>
.modal-close-button {
  font-size: 18px;
  border-radius: 4px;
  background-color: transparent;
}

.modal-close-button:hover {
  background-color: var(--c-secondary-300);
}
</style>
